import NavBar from "../../components/nav_bar";
import { HashLink as Link } from "react-router-hash-link";
import Notepad from "../../components/notepad";
import t from "../../locales";
import SystemMessage from "../../components/system_message";
import { pictures } from "../../store/pictures";
import youShareIcon from "../../assets/images/you_share.png";
import avatar from "../../assets/images/you_share/profile_picture.png";
import gridIcon from "../../assets/images/you_share/grid_on.svg";

export default function YouShareOverview() {
  return (
    <div>
      <SystemMessage text={t("youshare_system_message")} />
      <NavBar icon={youShareIcon} />
      <div className="you-share-account">
        <div className="you-share-account__stats-top">
          <div className="you-share-account__name">{t("youshare_name")}</div>
          <span className="you-share-account__extra">...</span>
        </div>
        <div className="you-share-account__top">
          <img src={avatar} className="you-share-account__avatar" />
          <div className="you-share-account__stats">
            <div className="you-share-account__stats-bottom">
              <div className="you-share-account__stat">
                <span className="you-share-account__number">
                  {t("youshare_posts_nr")}
                </span>
                <span className="you-share-account__unit">
                  {t("youshare_posts")}
                </span>
              </div>
              <div className="you-share-account__stat">
                <span className="you-share-account__number">
                  {t("youshare_followers_nr")}
                </span>
                <span className="you-share-account__unit">
                  {t("youshare_followers")}
                </span>
              </div>
              <div className="you-share-account__stat">
                <span className="you-share-account__number">
                  {t("youshare_following_nr")}
                </span>
                <span className="you-share-account__unit">
                  {t("youshare_following")}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="you-share-account__bottom">
          <p className="you-share-account__bold-text">Yannick Ekens</p>
          <p className="you-share-account__text">{t("youshare_more_info")}</p>
        </div>
      </div>
      <div className="you-share-middle-icon">
        <img src={gridIcon} />
      </div>
      <div className="you-share-pictures">
        {pictures.map((p) => (
          <Link to={`/youshare_details#${p.key}`} key={p.key}>
            <img src={p.file} alt="" />
          </Link>
        ))}
      </div>
      <Notepad />
    </div>
  );
}
